_collow.components.Cookies = class Cookies extends _collow.components.Base {
  root;
  elements;
  params;
  registrationId;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    const cookiesStatus = window.localStorage.getItem("cookies");
    if (cookiesStatus == 1) this.acceptHandler();
    if (cookiesStatus == 0) {
      root.setAttribute("hidden", "");
      return;
    }

    this.listen(elements.decline, "click", this.declineHandler);
    this.listen(elements.accept, "click", this.acceptHandler);
  }

  declineHandler = () => {
    window.localStorage.setItem("cookies", 0);
    this.root.setAttribute("hidden", "");
  };
  acceptHandler = () => {
    gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
    });

    window.localStorage.setItem("cookies", 1);
    this.root.setAttribute("hidden", "");
  };
};
